<template>
    <div id="company-screener">
        <ScreenerHeader
            :loading="loading"
            :saving="saving"
            :screener="screener"
            :screenerModified="screenerModified"
            @openSaveAsModal="openSaveAsModal"
            @openScreenerModal="openScreenerModal"
            @resetScreener="resetScreener"
            @saveScreener="saveScreener"
        />
        <AonContainer add-page-padding>
            <AonRow>
                <AonCol class="grid-cols-12">
                    <ScreenerCompanyTable v-if="!loading" />
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import ScreenerHeader from '@/components/screeners/ScreenerHeader.vue'
import ScreenerCompanyTable from '@/components/screeners/ScreenerCompanyTable.vue'
import { useSharedScreenerComposable } from '@/composables/screener'

const {
    loading,
    saving,
    screener,
    screenerModified,
    showSaveAsScreeners,
    queryFilters,
    closeSaveAsModal,
    saveScreener,
    resetScreener,
    openScreenerModal,
    openSaveAsModal,
} = useSharedScreenerComposable('COMPANY')
</script>

<style scoped lang="scss">
#company-screener {
    min-height: 100vh;
    height: 100%; // minus header nav and tabs
    width: 100%;

    .screener-tabs {
        height: 60px;
        border-top: 1px solid var(--color-stone-200);
    }
}
</style>
